import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

// Angular Material
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import { MatButtonModule, MatCheckboxModule, MatInputModule,
         MatSelectModule, MatRadioModule, MatCardModule,
         MatTableModule, MatPaginatorModule, MatSortModule,
         MatToolbarModule, MatSidenavModule, MatIconModule,
         MatListModule, MatGridListModule, MatMenuModule,
         MatStepperModule, MatExpansionModule } from '@angular/material';
// import {ErrorStateMatcher, showOnDirtyErrorStateMatcher} from '@angular/material/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';

import { ReactiveFormsModule } from '@angular/forms';
import { ToolbarComponent } from './component/toolbar/toolbar.component';
import { LayoutModule } from '@angular/cdk/layout';
import { DashComponent } from './component/dash/dash.component';
import { FormularioComponent } from './component/resumenes/formulario/formulario.component';
import { environment } from '../environments/environment';
import { ListaComponent } from './component/resumenes/lista/lista.component';
import { DetalleComponent } from './component/resumenes/detalle/detalle.component';


@NgModule({
  declarations: [
    AppComponent,
    ToolbarComponent,
    DashComponent,
    FormularioComponent,
    ListaComponent,
    DetalleComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatInputModule,
    MatSelectModule,
    MatRadioModule,
    MatCardModule,
    ReactiveFormsModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    LayoutModule,
    MatToolbarModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatGridListModule,
    MatMenuModule,
    MatStepperModule,
    MatExpansionModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule, // for database
    AngularFireAuthModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
